import {useNavigate, useParams} from 'react-router-dom';
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import {Button} from 'alm-react-components';
import {useContext, useEffect, useLayoutEffect, useState} from 'react';
import useLibrarySeeAll from '../../../hooks/useLibrarySeeAll';
import useSearchhook from '../../../hooks/useSearchhook';
import {useTranslation} from 'react-i18next';
import useGetEnrolled from '../../../hooks/useGetEnrolled';
import {librarySearch} from '../../../lib/utils';
import CarouselSection from '../../common/CarouselSection';
import {ActionType, APPROUTES, constants} from '../../../assets/constants/constants';
import Search from '../../common/Search';
import OtherSection from './OtherSection';
import getLocalizedContent from '../../../lib/getLocalizedMetaData';
import PageLoader from '../../common/loader/PageLoader';
import { AppContext } from '../../../context/AppProvider';

function Documents() {
  const navigate = useNavigate();
  const {getAllLibraryData, addBookMark, deleteBookMark, bookMarkresponse, data} =
    useLibrarySeeAll();
  const {keyword, onhandleSearch, onSearchClick} = useSearchhook();
  const {t} = useTranslation();
  const {tagsData} = useGetEnrolled();
  const {id} = useParams();
  const [loading, setLoading] = useState(true);
  const {dispatch } = useContext(AppContext);

  useEffect(() => {
    setLoading(true);
    getAllLibraryData(id).finally(() => {
      setLoading(false);
    });
  }, [bookMarkresponse, id]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Filter data based on search keyword
  const filteredData = keyword ? librarySearch(keyword, data) : data;

  return (
    <div>
      <div className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow">
        <div className="flex justify-between items-center">
          <Button
            onClick={() => {dispatch({ type: ActionType.SET_KEYWORD, payload:"" });navigate(APPROUTES.library)}}
            variant="default"
            className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
          >
            <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
          </Button>
          <Search onSearchClick={onSearchClick} onhandleSearch={onhandleSearch} />
        </div>
        {/* Display new documents section */}
        {loading ? (
          <div className="flex justify-center items-center h-[calc(100vh-32rem)] w-full">
            <PageLoader /> {/* Show the loader component here */}
          </div>
        ) : !filteredData.length ? (
          <div className="flex justify-center items-center h-[calc(100vh-32rem)] w-full text-2xl">
            <p><span dangerouslySetInnerHTML={{ __html: (t('Library.noDetailsFound')) }} /></p>
          </div>
        ) : (
          <>
            {filteredData.filter((item: any) =>
              item?.attributes?.tags?.includes(constants.NEW_DOCUMENT)
            ).length ? (<>
              <h2 className="text-3xl font-barlowLight mt-6"><span dangerouslySetInnerHTML={{ __html: (t('Documents.newDocuments')) }} /></h2>
              <CarouselSection
                type={constants.DOCUMENTS}
                data={filteredData.filter((item: any) =>
                  item?.attributes?.tags?.includes(constants.NEW_DOCUMENT)
                )}
                addBookMark={addBookMark}
                deleteBookMark={deleteBookMark}
                seeAll={true}
                filterTag={constants.NEW_DOCUMENT}
                catId={id}
              />
            </>) : null}

            {/* Render sections based on tagsData */}
            {tagsData?.map((res: any, index: number) => {
              const content = getLocalizedContent(res?.attributes?.localizedMetadata);
              const tagName = res?.attributes?.localizedMetadata[0]?.name;
              const tagFilteredData = filteredData.filter((item: any) =>
                item?.attributes?.tags?.includes(tagName)
              );

              return (
                <div key={index}>
                  {tagFilteredData.length ? (
                    <>
                      <h2 className="text-3xl font-barlowLight mt-6">{content?.name}</h2>
                      <CarouselSection
                        type={constants.DOCUMENTS}
                        data={tagFilteredData}
                        addBookMark={addBookMark}
                        deleteBookMark={deleteBookMark}
                        seeAll={true}
                        filterTag={tagName}
                        catId={id}
                      />
                    </>
                  ) : null}
                </div>
              );
            })}
            <OtherSection
              searchResult={filteredData}
              addBookMark={addBookMark}
              deleteBookMark={deleteBookMark}
              type={constants.DOCUMENTS}
              data={data}
              keyword={keyword}
              catId={id}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default Documents;
